import axios from "axios";
import { service } from "./service";

const isTest = false;

// eslint-disable-next-line
const ehudongUrl = isTest
  ? "http://testtv-h5.cztvcloud.com/ehudong/"
  : "https://ehudong.cztv.com/";

const dhudongUrl = isTest
  ? "http://testtv-h5.cztvcloud.com/dhudong/"
  : "https://dhudong.cztv.com/";

const snsUrl = isTest ? "http://10.30.129.75/" : "https://sns.cztv.com/"; // 后台域名

const APIPath = {
  getInfo: `${snsUrl}api/v3/videos-activity/info`, // 获取页面信息
  getVoteListApi: `${dhudongUrl}vote/getVoteOptionList`, // 获取投票列表
  getDetailApi: `${dhudongUrl}vote/getVoteOptionDetail`, // 获取详情页信息
  voteTvApi: `${ehudongUrl}vote/voteSnsActivity` // 投票接口
};
// 获取页面信息
export function getInfo (activityId) {
  return axios
    .get(`${APIPath.getInfo}?activityId=${activityId}`)
    .then(res => res.data);
}
// 获取投票列表
export function getVoteList (
  activityId,
  page = 1,
  keyword = "",
  pagenum = 10000
) {
  return axios
    .get(
      `${APIPath.getVoteListApi}?channel_id=1&activity_id=${activityId}&page=${page}&pagenum=${pagenum}&keyword=${keyword}`
    )
    .then(res => res.data);
}
// 获取详情页信息
export function getDetail (optionId) {
  return axios.get(`${APIPath.getDetailApi}?option_id=${optionId}`);
}

// 投票
export function voteTv (option_id) {
  return service({
    url: APIPath.voteTvApi,
    method: "POST",
    data: {
      option_id: option_id,
      token: window.mToken
      // token:
      //   "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOi8vMTAuMzAuMTI5Ljc1L2FwaS92Mi9pYmx1ZS9hdXRoL2xvZ2luIiwiaWF0IjoxNjQ4NjA1NTYwLCJleHAiOjE2NDk4MTUxNjAsIm5iZiI6MTY0ODYwNTU2MCwianRpIjoiSnFjZjJIdk8wdEhZT3BUQyIsInN1YiI6MSwicHJ2IjoiNDhlNDUzODMxY2ViYTVlNTdhNDc1ZTY4NjQ5Y2ZkZWU2ZTk3ZDhkMiJ9.SPlc-I8CX0qkCCuTDAGwaVK_Xu3-bkIeGIWZkHD78pQ"
    }
  }).then(res => res.data);
  // return axios
  //   .post(APIPath.voteTvApi, {
  //     option_id: option_id,
  //     token: window.mToken
  //   })
  //   .then(res => res.data);
}
